import { useInfiniteQueryBuilder, useMutationBuilder, useQueryBuilder } from "../useBuilders";
import { FETCH, MANAGE_ACCESS, STREAM_ACCESS, STREAM_ANALYTICS, UPDATE,  } from "../queryKeys";
import { streamAccessManagementApi } from "src/services/settings/streamAccess";

export const useStreamAccessFetch = () => {
  return useQueryBuilder([STREAM_ACCESS, FETCH], streamAccessManagementApi.fetchPrivateStreams);
};

export const useStreamAnalyticsFetch = (streamId?: string) => {
  return useQueryBuilder([STREAM_ANALYTICS, FETCH, streamId ?? ''], () => streamAccessManagementApi.fetchStreamAnalytics(streamId ?? ''), false, 60000, false, (data) => data, !!streamId);
};

export const useManageAccessFetch = (streamId?: string, searchQuery?: string ) => {
  return useInfiniteQueryBuilder(
    [MANAGE_ACCESS, FETCH, streamId ?? '', searchQuery ?? ''],
    ({ pageParam = 0 }) => streamAccessManagementApi.fetchAccess(pageParam, streamId ?? '', searchQuery ?? ''),
    0,
      (response) => {
        const nextPage = (response?.totalPages > response?.currentPage + 1) ? response?.currentPage + 1 : undefined;
        return nextPage;
      },
      undefined,
      !!streamId
    );
};

export const useUpdateAccess = (streamId?: string) => {
  return useMutationBuilder([MANAGE_ACCESS, UPDATE], streamAccessManagementApi.updateAccess, [MANAGE_ACCESS, FETCH, streamId ?? '', '']);
};